import React from 'react'


function Stat({ label, value }) {
    return (
        <div className='stat-item'>
            <div className='stat-label'>{label}</div>
            <div className='stat-value'>{value}</div>
        </div>
    )
}


function Stats({ score, questionNumber, totalQuestions }) {

    return (
        <div className='stats'>
            <Stat label="Pontuação" value={score} />
            <div className='stat-divider'></div>
            <Stat label="Questão" value={`${questionNumber} / ${totalQuestions}`} />
        </div>
    )
}

export default Stats